import React from 'react';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';

const ContactInfoCard = ({ icon: Icon, title, children, bgColor = 'gold' }) => {
  const bgColors = {
    gold: 'bg-gold bg-opacity-10',
    blue: 'bg-primary-blue bg-opacity-10',
    gray: 'bg-gray-100'
  };

  return (
    <div className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300">
      <div className={`w-12 h-12 ${bgColors[bgColor]} rounded-lg flex items-center justify-center flex-shrink-0`}>
        <Icon className={`w-6 h-6 ${bgColor === 'gold' ? 'text-gold' : 'text-primary-blue'}`} />
      </div>
      <div>
        <h4 className="font-semibold text-primary-blue mb-2">{title}</h4>
        <div className="text-dark-gray text-sm space-y-1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ContactInfoCard;